

import React, { useState } from "react";
import Foodreports from './Foodreports';
import CateringReports from '../Caterings/CateringReports';
import GlobalFilter from './GlobalFilter'; // Import the GlobalFilter

/* ---------- Dummy Section Component ---------- */
const DummySection = ({ title }) => {
  return (
    <div className="dummy-box">
      <h2>{title}</h2>
      <p>This is a dummy section for <strong>{title}</strong>.</p>
      <span>Content will be added later 🚧</span>
    </div>
  );
};

/* ---------- Main Company Component ---------- */
const Company = () => {
  // In Company.jsx - update the tabs array
  const tabs = [
    {
      id: 1,
      name: "FOOD& BEVERAGES",
      component: () => <Foodreports
        title="FOOD& BEVERAGES"
        filteredData={filteredData}  // ✅ Pass filtered data
        isLoading={isLoading}         // ✅ Pass loading state
      />
    },
    {
      id: 2, name: "Caterings", component: () => <CateringReports title="Company Structure" filteredData={filteredData}  // ✅ Pass filtered data
        isLoading={isLoading} />
    },
  ];

  const [activeTab, setActiveTab] = useState(tabs[0].id);
  const ActiveComponent = tabs.find(tab => tab.id === activeTab)?.component;

  // State for filtered data from GlobalFilter
  const [filteredData, setFilteredData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  // Handle filter changes
  const handleFilterChange = (data) => {
    setFilteredData(data);
    setIsLoading(false);
  };

  const handleLoadingChange = (loading) => {
    setIsLoading(loading);
  };

  return (
    <div className="company-container">
      {/* 🔹 Inline CSS */}
      <style>{`
        /* Default (Mobile first) */
        .company-scroll-container {
          position: static;
          background: #fff;
          padding: 10px 0;
        }

        .company-top-row {
          display: flex;
          align-items: center;
          justify-content: space-between;
          flex-wrap: wrap;
          gap: 12px;
        }

        .company-buttons-row {
          display: flex;
          gap: 6px;
          flex-wrap: wrap;
          flex: 1;
        }

        .company-button {
          padding: 8px 16px;
          border: none;
          background: #f0f0f0;
          cursor: pointer;
          border-radius: 6px;
          white-space: nowrap;
          font-size: 14px;
          font-weight: 500;
          transition: all 0.2s ease;
        }

        .company-button:hover {
          background: #e0e0e0;
        }

        .company-button.active {
          background: #e66d33;
          color: #fff;
        }

        .company-filter-wrapper {
          display: flex;
          align-items: center;
          flex-shrink: 0;
        }

        /* ✅ Desktop / Laptop only */
        @media (min-width: 769px) {
          .company-scroll-container {
            position: sticky;
            top: 0;
            z-index: 100;
            padding: 10px 0;
            background: #fff;
          }
        }

        /* Mobile Responsive */
        @media (max-width: 768px) {
          .company-top-row {
            flex-direction: column;
            align-items: stretch;
          }

          .company-buttons-row {
            justify-content: center;
          }

          .company-filter-wrapper {
            width: 100%;
          }

          .company-filter-wrapper .global-filter-container {
            width: 100%;
          }
        }

        @media (max-width: 480px) {
          .company-button {
            padding: 6px 12px;
            font-size: 12px;
          }
        }
      `}</style>

      {/* Tabs + Filter Row */}
      <div className="company-scroll-container">
        <div className="company-top-row">
          <div className="company-buttons-row">
            {tabs.map(tab => (
              <button
                key={tab.id}
                className={`company-button ${activeTab === tab.id ? "active" : ""}`}
                onClick={() => setActiveTab(tab.id)}
              >
                {tab.name}
              </button>
            ))}
          </div>

          {/* Global Filter Component - Same line as tabs */}
          <div className="company-filter-wrapper" style={{ marginTop: "37px" }}>
            <GlobalFilter
              onFilterChange={handleFilterChange}
              onLoadingChange={handleLoadingChange}
              isMobile={window.innerWidth <= 768}
              activeTab={activeTab === 1 ? 'overview' : 'catering'}
            />
          </div>
        </div>
      </div>

      {/* Active Section */}
      <div className="component-display">
        {ActiveComponent && <ActiveComponent />}
      </div>
    </div>
  );
};

export default Company;